module.exports = __webpack_public_path__ + "static/media/catalogo.b79994cb.pdf";